import { Theme } from '@theme'
import { StyleSheet } from 'react-native'

export default (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      width: '100%',
      justifyContent: 'space-between',
    },
    buttonContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'flex-end',
      paddingBottom: theme.spacing.md,
    },
    emailInput: {
      paddingTop: theme.spacing.xxxl,
      marginBottom: theme.spacing.sm,
    },
    emailConfirmInput: {
      marginBottom: theme.spacing.sm,
    },
    input: {
      marginBottom: theme.spacing.sm,
    },
    errorText: {
      marginBottom: theme.spacing.sm,
    },
  })
